import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const LineDivider = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6667 4.33333C12.6667 4.14924 12.5174 4 12.3333 4L4.33333 4C4.14924 4 4 4.14924 4 4.33333C4 4.51743 4.14924 4.66667 4.33333 4.66667L12.3333 4.66667C12.5174 4.66667 12.6667 4.51743 12.6667 4.33333ZM12.6667 6.33333C12.6667 6.14924 12.5174 6 12.3333 6H4.33333C4.14924 6 4 6.14924 4 6.33333C4 6.51743 4.14924 6.66667 4.33333 6.66667L12.3333 6.66667C12.5174 6.66667 12.6667 6.51743 12.6667 6.33333ZM12.3333 10C12.5174 10 12.6667 10.1492 12.6667 10.3333C12.6667 10.5174 12.5174 10.6667 12.3333 10.6667H4.33333C4.14924 10.6667 4 10.5174 4 10.3333C4 10.1492 4.14924 10 4.33333 10L12.3333 10ZM10 12.3333C10 12.1492 9.85076 12 9.66667 12H4.33333C4.14924 12 4 12.1492 4 12.3333C4 12.5174 4.14924 12.6667 4.33333 12.6667H9.66667C9.85076 12.6667 10 12.5174 10 12.3333Z"
          fill={color}
        />
        <rect
          x="14.667"
          y="8"
          width="0.666667"
          height="12.6667"
          rx="0.333333"
          transform="rotate(90 14.667 8)"
          fill={color}
        />
      </svg>
    )
  },
)

export default LineDivider
